import React from 'react';
import { Heart, Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const MatchesPage = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-primary-900 mb-2">
            Your Matches
          </h1>
          <p className="text-neutral-600">
            People you might connect with
          </p>
        </div>
        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Preferences
        </Button>
      </div>
      
      <Card>
        <CardContent className="p-12 text-center">
          <Heart className="h-16 w-16 text-neutral-400 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-neutral-700 mb-2">
            No Matches Yet
          </h3>
          <p className="text-neutral-500 mb-4">
            Complete your profile to find compatible travel companions
          </p>
          <Button>Complete Profile</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default MatchesPage;
